var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d96b80ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/Sidebar/SidebarMinimizer.vue
// module id = 930
// module chunks = 1